import { render } from "./tanchuang.vue?vue&type=template&id=bea17dcc"
import script from "./tanchuang.vue?vue&type=script&lang=js"
export * from "./tanchuang.vue?vue&type=script&lang=js"

import "./tanchuang.vue?vue&type=style&index=0&id=bea17dcc&lang=css"

import exportComponent from "D:\\web\\dmsm\\dmsm-pages\\cloud\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__